module.exports = __webpack_public_path__ + "img/name_on_card.430cf8e9.svg";